function strcmp(s1, s2) {
    return ((s1 == s2) ? 0 : ((s1 > s2) ? 1 : -1));
}

function extractQueryString(string) {
    if (string.charAt(0) == '?') {
        string = string.substring(1);
    }
    var paramPairs = string.split("&");
    var params = [];
    if (paramPairs != "") {

        for (var i in paramPairs) {
            var keyPair = paramPairs[i].split('=');
            if (keyPair.length == 1) {
                keyPair[1] = '1';
            }
            params[keyPair[0]] = keyPair[1].replace(/\+/g, ' ');
        }
    }
    return params;
}

function makeQueryString(keyPairs) {
    var string = '';
    for (var i = 0; i < keyPairs.length; i += 2) {
        if (keyPairs[i + 1]) {
            if (i !== 0 && string != '') {
                string += '&';
            }
            string += keyPairs[i] + '=' + encodeURIComponent(keyPairs[i + 1]);
        }
    }
    return string;
}

var addEvent = (function () {
    addEvent = function (obj, type, fn) {
        if (obj == null || typeof obj !== 'object') {
            return;
        }
        obj.addEventListener(type, fn, false);
    };
    return addEvent;
})();

var removeEvent = (function () {
    if (document.detachEvent) {
        removeEvent = function (obj, type, fn) {
            obj.detachEvent('on' + type, obj[type + fn]);
            obj[type + fn] = null;
        };
    } else {
        removeEvent = function (obj, type, fn) {
            obj.removeEventListener(type, fn, false);
        };
    }
    return removeEvent;
})();

function isMouseLeaveOrEnter(e, handler) {
    var reltg = e.relatedTarget ? e.relatedTarget : (e.type == 'mouseout' ? e.toElement : e.fromElement);
    while (reltg && reltg != handler) {
        reltg = reltg.parentNode;
    }
    return (reltg != handler);
}

function getSelectedValue(radioObj) {
    for (var i = 0; i < radioObj.length; i++) {
        if (radioObj[i].checked) {
            return radioObj[i].value;
        }
    }
}

function getCheckedValues(select) {
    var checkedValues = [];
    if (typeof (select.checked) == 'undefined') {
        for (var i = 0; i < select.length; i++) {
            if (select[i].checked) {
                checkedValues[checkedValues.length] = select[i].value;
            }
        }
    } else if (select.checked) {
        checkedValues[0] = select.value;
    }
    return checkedValues;
}

Object.extend = function (d, s) {
    for (var p in s) {
        d[p] = s[p];
    }
    return d;
}

function getLeft(l) {
    if (l.offsetParent) {
        return l.offsetLeft + getLeft(l.offsetParent);
    } else {
        return l.offsetLeft;
    }
}

function getTop(l) {
    if (l.offsetParent) {
        return (l.offsetTop + getTop(l.offsetParent));
    } else {
        return l.offsetTop;
    }
}

function print_r(a) {
    var t = "";
    for (var i in a) {
        t += i + ': ' + a[i] + '\n';
    }
    var n = window.open('', '', 'height=700,width=300,toolbar=0,location=0,scrollbars=1,menubar=0,resizable=0');
    n.document.write('<pre>' + t + '</pre>')
}

function jsonToString(j) {
    var s = '';
    for (var i in j) {
        s += i + j[i];
    }
    return s;
}

function getParent(srcObj, targetNode) {
    var target = srcObj;
    while (target.nodeName != targetNode) {
        target = target.parentNode;
        if (target.nodeName == 'BODY') {
            return null;
        }
    }
    return target;
}

function getCookie(check_name) {
    var a_all_cookies = document.cookie.split(';');
    var a_temp_cookie = '';
    var cookie_name = '';
    var cookie_value = '';
    var b_cookie_found = false; // set boolean t/f default f

    for (var i = 0; i < a_all_cookies.length; i++) {
        a_temp_cookie = a_all_cookies[i].split('=');
        cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');
        if (cookie_name == check_name) {
            b_cookie_found = true;
            if (a_temp_cookie.length > 1) {
                cookie_value = unescape(a_temp_cookie[1].replace(/^\s+|\s+$/g, ''));
            }
            return cookie_value;
        }
        a_temp_cookie = null;
        cookie_name = '';
    }
    if (!b_cookie_found) {
        return null;
    }
}

//http://tinyurl.com/3amk267 StackOverflow
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function removeClass(e, c) {
    var r = new RegExp('(\\s|^)' + c + '(\\s|$)');
    e.className = e.className.replace(r, ' ');
}

function hasClass(e, c) {
    return e.className.match(new RegExp('(\\s|^)' + c + '(\\s|$)'));
}

function addClass(e, c) {
    if (!this.hasClass(e, c)) {
        e.className += " " + c
    }
}

function stringCutter(s, maxLength, keepEnding, endLength) {
    endLength = endLength || 5;
    if (s.length <= maxLength) {
        return s;
    } else {
        if (keepEnding) {
            return s.substr(0, maxLength - endLength - 3) + '...' + s.substr(s.length - endLength);
        } else {
            return s.substr(0, maxLength - 3) + '...';
        }
    }
}
